import { render, staticRenderFns } from "./AdminOnboardingLayout.vue?vue&type=template&id=ee6d65ac&scoped=true"
import script from "./AdminOnboardingLayout.vue?vue&type=script&lang=js"
export * from "./AdminOnboardingLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminOnboardingLayout.vue?vue&type=style&index=0&id=ee6d65ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6d65ac",
  null
  
)

export default component.exports